import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "rd-animate-spin -rd-ml-1 rd-mr-2 rd-h-4 rd-w-4",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.component.customData.action && _ctx.component.customData.action.type === _ctx.ButtonActionType.Link)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: _ctx.component.customData.action.values ?? undefined,
        class: _normalizeClass([_ctx.component.styles.cssClass, _ctx.component.customData.buttonSize]),
        target: "_blank",
        style: _normalizeStyle({
                borderRadius: _ctx.component.styles.borderRadius ? _ctx.component.styles.borderRadius + 'px' : '',
                borderWidth: _ctx.component.styles.outlineWeight ? _ctx.component.styles.outlineWeight + 'px !important' : '',
                borderColor: _ctx.component.styles.outlineColor + ' !important',
                width: _ctx.component.styles.fullWidth ? '100%' : '',
                '--base-font-family': _ctx.component.styles.fontFamily,
                '--button-text-color': !_ctx.isNeutralButton ? _ctx.component.styles.fontColor : '',
                '--button-hover-color': !_ctx.isNeutralButton ? _ctx.component.styles.hoverColor : '',
                '--button-hover-text-color': !_ctx.isNeutralButton ? _ctx.component.styles.hoverTextColor : '',
                '--button-color': !_ctx.isNeutralButton ? _ctx.component.styles.backgroundColor : '',
                '--neutral-button-color': (_ctx.isNeutralButton && _ctx.component.styles.backgroundColor) ? _ctx.component.styles.backgroundColor : '',
                '--neutral-button-text-color': (_ctx.isNeutralButton && _ctx.component.styles.fontColor) ? _ctx.component.styles.fontColor : '',
                '--neutral-button-hover-color': (_ctx.isNeutralButton && _ctx.component.styles.hoverColor) ? _ctx.component.styles.hoverColor : '',
                '--neutral-button-hover-text-color': (_ctx.isNeutralButton && _ctx.component.styles.hoverTextColor) ? _ctx.component.styles.hoverTextColor : ''
            })
      }, [
        (_ctx.component.customData.icon && _ctx.component.customData.iconPosition == 'left')
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: _normalizeClass([`fa-solid fa-${_ctx.component.customData.icon}`,
            { 'rd-me-1': _ctx.component.customData.text }]),
              "aria-hidden": "true"
            }, null, 2))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.component.customData.text) + " ", 1),
        (_ctx.component.customData.icon && _ctx.component.customData.iconPosition == 'right')
          ? (_openBlock(), _createElementBlock("i", {
              key: 1,
              class: _normalizeClass([`fa-solid fa-${_ctx.component.customData.icon}`,
            { 'rd-ms-1': _ctx.component.customData.text }]),
              "aria-hidden": "true"
            }, null, 2))
          : _createCommentVNode("", true)
      ], 14, _hoisted_1))
    : (_ctx.showButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: _normalizeClass([_ctx.component.styles.cssClass, _ctx.component.customData.buttonSize, _ctx.getProcessing]),
          style: _normalizeStyle({
                borderRadius: _ctx.component.styles.borderRadius ? _ctx.component.styles.borderRadius + 'px' : '',
                borderWidth: _ctx.component.styles.outlineWeight ? _ctx.component.styles.outlineWeight + 'px !important' : '',
                borderColor: _ctx.component.styles.outlineColor + ' !important',
                width: _ctx.component.styles.fullWidth ? '100%' : '',
                '--base-font-family': _ctx.component.styles.fontFamily,
                '--button-text-color': !_ctx.isNeutralButton ? _ctx.component.styles.fontColor : '',
                '--button-hover-color': !_ctx.isNeutralButton ? _ctx.component.styles.hoverColor : '',
                '--button-hover-text-color': !_ctx.isNeutralButton ? _ctx.component.styles.hoverTextColor : '',
                '--button-color': !_ctx.isNeutralButton ? _ctx.component.styles.backgroundColor : '',
                '--neutral-button-color': (_ctx.isNeutralButton && _ctx.component.styles.backgroundColor) ? _ctx.component.styles.backgroundColor : '',
                '--neutral-button-text-color': (_ctx.isNeutralButton && _ctx.component.styles.fontColor) ? _ctx.component.styles.fontColor : '',
                '--neutral-button-hover-color': (_ctx.isNeutralButton && _ctx.component.styles.hoverColor) ? _ctx.component.styles.hoverColor : '',
                '--neutral-button-hover-text-color': (_ctx.isNeutralButton && _ctx.component.styles.hoverTextColor) ? _ctx.component.styles.hoverTextColor : ''
            }),
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleAction && _ctx.handleAction(...args)), ["stop"])),
          disabled: _ctx.disabled
        }, [
          (_ctx.processing)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _cache[1] || (_cache[1] = [
                _createElementVNode("circle", {
                  class: "opacity-25",
                  cx: "12",
                  cy: "12",
                  r: "10",
                  stroke: "currentColor",
                  "stroke-width": "4"
                }, null, -1),
                _createElementVNode("path", {
                  class: "rd-opacity-75",
                  fill: "currentColor",
                  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                }, null, -1)
              ])))
            : _createCommentVNode("", true),
          (_ctx.component.customData.icon && _ctx.component.customData.iconPosition == 'left')
            ? (_openBlock(), _createElementBlock("i", {
                key: 1,
                class: _normalizeClass([`fa-solid fa-${_ctx.component.customData.icon}`,
            { 'rd-me-1': _ctx.component.customData.text }]),
                "aria-hidden": "true"
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.hasButtonTextSlot)
            ? _renderSlot(_ctx.$slots, "buttonText", { key: 2 })
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createTextVNode(_toDisplayString(_ctx.component.customData.text), 1)
              ], 64)),
          (_ctx.component.customData.icon && _ctx.component.customData.iconPosition == 'right')
            ? (_openBlock(), _createElementBlock("i", {
                key: 4,
                class: _normalizeClass([`fa-solid fa-${_ctx.component.customData.icon}`,
            { 'rd-ms-1': _ctx.component.customData.text }]),
                "aria-hidden": "true"
              }, null, 2))
            : _createCommentVNode("", true)
        ], 14, _hoisted_2))
      : _createCommentVNode("", true)
}